import { render, staticRenderFns } from "./StaffAssigned.vue?vue&type=template&id=fe429b9a"
import script from "./StaffAssigned.vue?vue&type=script&lang=js"
export * from "./StaffAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports